<template lang="html">
    <div>
        <div ref="parentSidebar" id="parentx">
            <v-btn v-if="validaFilter" @click="ActivarSide()" color="primary" class="btn-flotante transition delay-150 duration-300 ease-in-out transform hover:scale-5 text-white rounded-md" style="position:fixed;">
                <v-icon color="white">mdi-filter</v-icon>
            </v-btn>

            <vs-sidebar position-right default-index="1" color="#34495e" class="sidebarx" spacer click-not-close v-model="active">

                <div class="header-sidebar" slot="header">
                    <h4 class=" greyTint--text">
                        Filtros
                        <v-icon color="greyTint">mdi-filter</v-icon>
                        <v-btn class="ma-2" @click="active=false; emitir()" color="red" dark><v-icon dark>mdi-close-outline</v-icon></v-btn>
                    </h4>


                </div>
                <vs-sidebar-item index="2" class="flex justify-center">
                    <span class="align-baseline text-base text-gray-600">Filtro Seguimiento:</span>
                </vs-sidebar-item>
                <vs-sidebar-item index="1">
                    <multiselect v-model="filter" deselect-label="No se puede remover"
                                 selected-label="Seleccionado" select-label="Seleccionar valor"
                                 track-by="value" label="text" placeholder="Seleccionar filtro seguimiento"
                                 :options="itemsFiltros" :allow-empty="false"
                                 style=" width: 92%;">
                        <template slot="clear" slot-scope="props">
                            <div class="multiselect__clear" v-if="filter != ''" @mousedown.prevent.stop="filter=''"></div>
                        </template>
                    </multiselect>
                </vs-sidebar-item>

                <vs-divider position="left"></vs-divider>
                <vs-sidebar-item index="1">
                    <multiselect v-model="aseguradora" deselect-label="Seleccione para remover"
                                 selected-label="Seleccionado" select-label="Seleccionar valor"
                                 track-by="clclave" label="clnombre" placeholder="Seleccionar Aseguradora"
                                 :options="aseguradoras" :allow-empty="true"
                                 style=" width: 92%;">
                        <template slot="clear" slot-scope="props">
                            <div class="multiselect__clear" v-if="aseguradora != ''" @mousedown.prevent.stop="aseguradora=''"></div>
                        </template>
                    </multiselect>
                </vs-sidebar-item>
                <vs-divider position="left"></vs-divider>

                <vs-sidebar-item index="3">
                    <multiselect v-model="estado" deselect-label="Seleccione para remover"
                                 selected-label="Seleccionado" select-label="Seleccionar valor" track-by="esclave"
                                 label="esnombre" placeholder="Seleccionar Estado" :options="estados" :allow-empty="true"
                                 @input="obtenerLocalidades()"
                                 style="width: 92%;">
                        <template slot="clear" slot-scope="props">
                            <div class="multiselect__clear" v-if="estado != ''" @mousedown.prevent.stop="estado = ''"></div>
                        </template>
                    </multiselect>
                </vs-sidebar-item>
                <vs-divider position="left"></vs-divider>
                <vs-sidebar-item index="4">
                    <multiselect v-model="localidad" deselect-label="Seleccione para remover"
                                 selected-label="Seleccionado" select-label="Seleccionar valor"
                                 track-by="loclave" label="lonombre" placeholder="Seleccionar Localidades"
                                 :options="localidades" :allow-empty="true"
                                 style="width: 92%;">
                        <template slot="clear" slot-scope="props">
                            <div class="multiselect__clear" v-if="localidad != ''" @mousedown.prevent.stop="localidad=''"></div>
                        </template>
                    </multiselect>
                </vs-sidebar-item>
                <vs-divider position="left"></vs-divider>
                <vs-sidebar-item index="5">
                    <multiselect v-model="relevancia" deselect-label="Seleccione para remover"
                                 selected-label="Seleccionado" select-label="Seleccionar valor"
                                 track-by="rclave" label="rdescripcion" placeholder="Seleccionar Relevancia"
                                 :options="relevancias" :allow-empty="true"
                                 style="width: 92%;">
                        <template slot="clear" slot-scope="props">
                            <div class="multiselect__clear" v-if="relevancia != ''" @mousedown.prevent.stop="relevancia=''"></div>
                        </template>
                    </multiselect>
                </vs-sidebar-item>

                <vs-divider position="left"></vs-divider>
                <vs-sidebar-item index="6">
                    <multiselect v-model="asistencia" deselect-label="Seleccione para remover"
                                 selected-label="Seleccionado" select-label="Seleccionar valor"
                                 track-by="aiclave" label="ainombre" placeholder="Seleccionar Asistencia"
                                 :options="asistencias" :allow-empty="true"
                                 style="width: 92%;">
                        <template slot="clear" slot-scope="props">
                            <div class="multiselect__clear" v-if="asistencia != ''" @mousedown.prevent.stop="asistencia=''"></div>
                        </template>
                    </multiselect>
                </vs-sidebar-item>

                <vs-divider position="left" v-if="selectedOption != 0"></vs-divider>
                <vs-sidebar-item index="7" v-if="selectedOption != 0">
                    <multiselect v-model="usuario" deselect-label="Seleccione para remover"
                                 selected-label="Seleccionado" select-label="Seleccionar valor"
                                 track-by="uslogin" label="usnom" placeholder="Seleccionar Usuario"
                                 :options="usuarios" :allow-empty="true"
                                 style="width: 92%;">
                        <template slot="clear" slot-scope="props">
                            <div class="multiselect__clear" v-if="usuario != ''" @mousedown.prevent.stop="usuario=''"></div>
                        </template>
                    </multiselect>
                </vs-sidebar-item>

                <vs-divider position="left"></vs-divider>

                <vs-sidebar-item index="2" class="flex justify-center">
                    <span class="align-baseline text-base text-gray-600">Estatus Conductor:</span>
                </vs-sidebar-item>
                <vs-sidebar-item index="2" class="flex justify-center">
                    <v-radio-group row v-model="conductor" inline>
                        <v-radio label="Liberado" value="1"></v-radio>
                        <v-radio label="Detenido" value="0"></v-radio>
                    </v-radio-group>
                </vs-sidebar-item>


                <vs-divider position="left"></vs-divider>
                <vs-sidebar-item index="2" class="flex justify-center">
                    <span class="align-baseline text-base text-gray-600">Arribo:</span>
                </vs-sidebar-item>
                <vs-sidebar-item index="2" class="flex justify-center">
                    <v-radio-group row v-model="arribo" inline>
                        <v-radio label="Sí" value="1"></v-radio>
                        <v-radio label="No" value="0"></v-radio>
                    </v-radio-group>
                </vs-sidebar-item>

                <vs-divider position="left"></vs-divider>
                <vs-sidebar-item index="2" class="flex justify-center">
                    <span class="align-baseline text-base text-gray-600">Término:</span>
                </vs-sidebar-item>
                <vs-sidebar-item index="2" class="flex justify-center">
                    <v-radio-group row v-model="termino" inline>
                        <v-radio label="Sí" value="1"></v-radio>
                        <v-radio label="No" value="0"></v-radio>
                    </v-radio-group>
                </vs-sidebar-item>

                <vs-divider position="left"></vs-divider>

                <vs-sidebar-item index="2" class="flex justify-center">
                    <span class="align-baseline text-base text-gray-600">Vehículo detenido:</span>
                </vs-sidebar-item>
                <vs-sidebar-item index="2" class="flex justify-center">
                    <v-radio-group row v-model="vhdetenido" inline>
                        <v-radio label="Sí" value="1"></v-radio>
                        <v-radio label="No" value="0"></v-radio>
                    </v-radio-group>
                </vs-sidebar-item>

                <vs-divider position="left"></vs-divider>
                <vs-sidebar-item index="2" class="flex justify-center">
                    <span class="align-baseline text-base text-gray-600">Pendiente Whatsapp:</span>
                </vs-sidebar-item>
                <vs-sidebar-item index="2" class="flex justify-center">
                    <v-radio-group row v-model="pendiwhats" inline>
                        <v-radio label="Sí" value="1"></v-radio>
                        <v-radio label="No" value="0"></v-radio>
                    </v-radio-group>
                </vs-sidebar-item>


                <div class="footer-sidebar" slot="footer">
                    <vs-row>
                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
                            <v-btn class="ma-2" @click="buscar()" color="blue" dark>Buscar <v-icon dark right>mdi-table-search</v-icon></v-btn>
                        </vs-col>
                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
                            <v-btn class="ma-2" @click="limpiarBusqueda()" color="red" dark>Limpiar <v-icon dark right>mdi-trash-can</v-icon></v-btn>
                        </vs-col>
                    </vs-row>
                </div>

            </vs-sidebar>
        </div>


    </div>
</template>

<script>
    import { mapGetters, mapState, mapMutations } from 'vuex';
    import SidebarService from '@/services/shared/sidebar.service.js';
    import Lideres from "@/services/Lideres/Lideres.service.js";
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
    import dash from '@/services/Dashboard/Dashboard.service.js';
    import LideresService from '@/services/Lideres/Lideres.service.js';

    export default {
        props: {
            validaFilter: false,
            selectedOption:0
        },
        data() {
            return {
                active: false,
                uslogin: '',
                busqueda: {},

                filter: 0,
                aseguradora: '',
                estado: '',
                localidad: '',
                relevancia: '',
                asistencia: '',
                usuario: '',
                conductor: '',
                arribo: '',
                termino: '',
                vhdetenido: '',
                pendiwhats: '',


                itemsFiltros: [],
                aseguradoras: [],
                estados: [],
                localidades: [],
                relevancias: [],
                asistencias: [],
                usuarios: [],

               
            }
        },
        computed: {
            ...mapState(['permission', 'domain']),
            ...mapGetters(['getUser', 'THEME_STATE'])
        },
        watch: {
            'selectedOption'(val){
                this.usuario = '';
            }

        },
        methods: {
            async obtenerLocalidades() {
                this.localidad = '';
                this.localidades = [];
                if (this.estado != null) {
                    let resp = await LideresService.obtenerLocalidades(this);
                    this.localidades = resp;

                }


            },
            async emitir() {
                this.busqueda = {};
                this.busqueda = {
                    filter: this.filter != '' && this.filter != null ? this.filter.value : '',
                    aseguradora: this.aseguradora != '' && this.aseguradora != null ? this.aseguradora.clclave : '',
                    estado: this.estado != '' && this.estado != null ? this.estado.esclave : '',
                    localidad: this.localidad != '' && this.localidad != null ? this.localidad.loclave : '',
                    relevancia: this.relevancia != '' && this.relevancia != null ? this.relevancia.rclave : '',
                    asistencia: this.asistencia != '' && this.asistencia != null ? this.asistencia.aiclave : '',
                    usuario: this.usuario != '' && this.usuario != null && this.selectedOption != 0 ? this.usuario.uslogin : '',
                    conductor: this.conductor != '' && this.conductor != null ? this.conductor : '',
                    arribo: this.arribo != '' && this.arribo != null ? this.arribo : '',
                    termino: this.termino != '' && this.termino != null ? this.termino : '',
                    vhdetenido: this.vhdetenido != '' && this.vhdetenido != null ? this.vhdetenido : '',
                    pendiwhats: this.pendiwhats != '' && this.pendiwhats != null ? this.pendiwhats : '',
                }
                this.$emit("guardaB", this.busqueda);
            },

            async buscar() {
                this.busqueda = {};
                this.busqueda = {
                    filter: this.filter != '' && this.filter != null ? this.filter.value : '',
                    aseguradora: this.aseguradora != '' && this.aseguradora != null ? this.aseguradora.clclave : '',
                    estado: this.estado != '' && this.estado != null ? this.estado.esclave : '',
                    localidad: this.localidad != '' && this.localidad != null ? this.localidad.loclave : '',
                    relevancia: this.relevancia != '' && this.relevancia != null ? this.relevancia.rclave : '',
                    asistencia: this.asistencia != '' && this.asistencia != null ? this.asistencia.aiclave : '',
                    usuario: this.usuario != '' && this.usuario != null && this.selectedOption != 0 ? this.usuario.uslogin : '',
                    conductor: this.conductor != '' && this.conductor != null ? this.conductor : '',
                    arribo: this.arribo != '' && this.arribo != null ? this.arribo : '',
                    termino: this.termino != '' && this.termino != null ? this.termino : '',
                    vhdetenido: this.vhdetenido != '' && this.vhdetenido != null ? this.vhdetenido : '',
                    pendiwhats: this.pendiwhats != '' && this.pendiwhats != null ? this.pendiwhats : '',
                }
                this.active = false;
                this.$emit("realizarB", this.busqueda);
            },
            async limpiarBusqueda() {
                this.filter = { text: this.itemsFiltros[0].text, value: this.itemsFiltros[0].value };
                this.aseguradora = '';
                this.estado = '';
                this.localidad = '';
                this.relevancia = '';
                this.asistencia = '';
                this.usuario = '';
                this.conductor = '';
                this.arribo = '';
                this.termino = '';
                this.vhdetenido = '';
                this.pendiwhats = '';

                await this.buscar();

               
            },
            temaSidebar() {
                if (this.THEME_STATE) {
                    document.getElementsByClassName('vs-sidebar')[0].style.background = '#23232d';

                } else {
                    document.getElementsByClassName('vs-sidebar')[0].style.background = '#FFFFFF';
                }
            },

            async ActivarSide() {
                this.active = true;
                this.busqueda = {};
                

            }
        },
        async mounted() {
            setTimeout(() => {
                this.temaSidebar();
                this.active = false;
            }, 400);
            this.uslogin = MetodosGenerales.ObtenerUserName();
            await LideresService.obtenerFiltros(this);
            await LideresService.obtenerAseguradoras(this);
            await LideresService.obtenerEstados(this);
            await LideresService.obtenerRelevancia(this);
            await LideresService.obtenerAsistencias(this);
            await LideresService.obtenerUsuarios(this);
            


        },
    }
</script>

<style scope>
    .checkbox-inline {
        display: flex;
    }

        .checkbox-inline .v-input {
            margin-right: 10px; /* Espacio entre los checkboxes */
        }
    .header-sidebar {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
    }

        .header-sidebar h4 {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
        }

            .header-sidebar h4 > button {
                margin-left: 10px;
            }

    .footer-sidebar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
    }

        .footer-sidebar > button {
            border: 0px solid rgba(0,0,0,0) !important;
            border-left: 1px solid rgba(0,0,0,0.07) !important;
            border-radius: 0px !important;
        }

    .vs-sidebar {
        max-width: 350px !important;
    }

        .vs-sidebar.vs-sidebar-parent {
            position: fixed !important;
        }

    .vs-sidebar--background {
        background: none !important;
    }

    /*FLOTANTE  */
    .btn-flotante {
        text-transform: uppercase; /* Texto en mayusculas */
        border-radius: 10px; /* Borde del boton */
        background-color: #747d8c; /* Color de fondo */
        padding: 2px 6px; /* Relleno del boton */
        position: fixed;
        top: 75px;
        right: 6px;
        transition: all 300ms ease 0ms;
        box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
        z-index: 99;
        opacity: 0.5;
    }

        .btn-flotante:hover {
            background-color: #2f3542; /* Color de fondo al pasar el cursor */
            box-shadow: 0px 15px 20px rgba(0, 0, 0, 0.3);
            transform: translateY(-7px);
        }

    @media only screen and (max-width: 600px) {
        .btn-flotante {
            padding: 2px 6px;
        }
    }
</style>